import { createFileRoute } from "@tanstack/react-router";
import { ProductModelsPage } from "../../../components/products/ProductModelsPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/data-catalog/product-models")({
  beforeLoad: requireSuperAdmin(),
  component: ProductModelsPage,
});
